/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamMember
 */
export interface TeamMember {
    /**
     * 
     * @type {string}
     * @memberof TeamMember
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMember
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMember
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMember
     */
    photo?: string;
}

/**
 * Check if a given object implements the TeamMember interface.
 */
export function instanceOfTeamMember(value: object): value is TeamMember {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function TeamMemberFromJSON(json: any): TeamMember {
    return TeamMemberFromJSONTyped(json, false);
}

export function TeamMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamMember {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'email': json['email'],
        'photo': json['photo'] == null ? undefined : json['photo'],
    };
}

export function TeamMemberToJSON(value?: TeamMember | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
        'photo': value['photo'],
    };
}

